const LETTER_MAP = {
	â: "a",
	Â: "A",
	à: "a",
	À: "A",
	á: "a",
	Á: "A",
	ã: "a",
	Ã: "A",
	ê: "e",
	Ê: "E",
	è: "e",
	È: "E",
	é: "e",
	É: "E",
	î: "i",
	Î: "I",
	ì: "i",
	Ì: "I",
	í: "i",
	Í: "I",
	õ: "o",
	Õ: "O",
	ô: "o",
	Ô: "O",
	ò: "o",
	Ò: "O",
	ó: "o",
	Ó: "O",
	ü: "u",
	Ü: "U",
	û: "u",
	Û: "U",
	ú: "u",
	Ú: "U",
	ù: "u",
	Ù: "U",
	ç: "c",
	Ç: "C"
};

export default class StringHelper {
	static cleanLetters(letter) {
		return LETTER_MAP[letter] || letter;
	}

	static removeAccentuation(string) {
		// eslint-disable-next-line no-useless-escape
		return string.replace(/[\W\[\] ]/g, StringHelper.cleanLetters);
	}

	static removeWhiteSpace(string) {
		return string.replace(/\s/g, "");
	}

	static onlyNumbers(string) {
		if (!StringHelper.isString(string)) {
			return string
		}

		return string.replace(/[^\d]/ig, "");
	}

	static alphanumericOnly(string) {
		if (!StringHelper.isString(string)) {
			return string
		}

		return string.replace(/[\W | _]*/g, "");
	}

	static isString(value) {
		return typeof value === "string";
	}

	static formatCurrency(number, prefix=true, locale='pt-BR', currency="BRL") {
		if (typeof number === 'string' && /\d/.test(number.replace(/\./g, '')) || typeof number === 'number') {
			const _currency = new Intl.NumberFormat(locale, { style: 'currency', currency }).format(number);

			if (!prefix) {
				return _currency.replace('R$', '').trim();
			}

			return _currency;
		}

		return number;
	}

	static formatPercent(number) {

		if (typeof number === 'string') {

			if (!number) {
				return number;
			}

			number = parseFloat(number);
		}

		if (typeof number === 'number') {
			number = number.toFixed(2);
			number = number.toString();
		}


		if (typeof number === 'string' && /\d/.test(number.replace(/\./g, ''))) {
			return number.replace('.', ',') + ' %';
		}

		return number;
	}

	static formatCPF(string) {

		if (typeof string === 'string') {
			if (string != "" && string != null) {
				string = string.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
			}
		}

		return string;
	}
}
